// extracted by mini-css-extract-plugin
export var menuIcon = "_ni-0";
export var menuIconInline = "_ni-1";